import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from 'react-router-dom';
import '../../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../../Components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";
import positionSvg from '../../../assets/images/svg/position.svg'
import { numberWithCommas } from "../../../helpers/globalHelper"
import toastr from "toastr";

import DeleteModal from '../../../Components/Common/DeleteModal';

import { Col, Row, UncontrolledTooltip, Modal, ModalHeader, ModalBody, Form, Input, FormFeedback, Label, Card, CardBody, Button } from "reactstrap";

//flatpickr
import "flatpickr/dist/themes/material_green.css";
import Spinners from "Components/Common/Spinner";
import { useDepartmentFindAllQuery, useOrgFindAllQuery, usePositionCreateMutation, usePositionDeleteMutation, usePositionFindAllQuery, usePositionUpdateMutation } from '../../../store';

const Detail = () => {
  const [customQuery, setCustomQuery] = useState<any>();
  const [isLoading, setLoading] = useState(true)

  const [modal, setModal] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [positionOne, setPositionOne] = useState<any>(null)
  const [positionList, setPositionList] = useState<any>();
  const [departmentList, setDepartmentList] = useState<any>();
  const [orgList, setOrgList] = useState<any>();
  const [positionCount, setPositionCount] = useState<any>();



  const {
    data: positionData,
    error: positionError,
    isFetching: isPositionFetching,
  } = usePositionFindAllQuery(customQuery);

  const {
    data: orgData,
    error: orgError,
    isFetching: isOrgFetching,
  } = useOrgFindAllQuery();

  const {
    data: departmentData,
    error: departmentError,
    isFetching: isDepartmentFetching,
  } = useDepartmentFindAllQuery();

  const [positionCreate, positionCreateResult] = usePositionCreateMutation();
  const [positionUpdate, positionUpdateResult] = usePositionUpdateMutation();
  const [positionDelete, positionDeleteResult] = usePositionDeleteMutation();

  // Datatable дээр pagination харуулахад хэрэгтэй
  const [customPagination, setCustomPagination] = useState<any>();
  const [customPageSize, setCustomPageSize] = useState<any>();
  const [customPageLength, setCustomPageLength] = useState<any>();

  useEffect(() => {
    setPositionList(positionData?.data)
    setOrgList(orgData?.data)
    setLoading(false)
    setDepartmentList(departmentData?.data)
    setPositionCount(positionList?.length)

    setCustomPagination(positionData?.pagination);
    const tempQuery = `?page=${customPageLength !== undefined ? customPageLength : 1}&pageSize=${customPageSize !== undefined ? customPageSize : 25}`;
    setCustomQuery(tempQuery)
  }, [positionData, positionList, customPageSize, customPageLength, customPagination])


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPositionOne(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleJobClick = useCallback((arg: any) => {
    const tempPosition = arg;
    setPositionOne({
      position_id: tempPosition.position_id,
      position_name: tempPosition.position_name,
      position_display: tempPosition.position_display,
      department_id: tempPosition.department_id,
      organization_id: tempPosition.organization_id
    });
    setIsEdit(true);
    toggle();
  }, []);

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false);

  const onClickDelete = (selectRowData) => {
    setPositionOne(selectRowData);
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (positionOne) {
      console.log(positionOne)
      positionDelete(positionOne.position_id)
        .unwrap()
        .then((response) => {
          toastr.success("Мэдээлэл амжилттай устсан!", "Амжилттай");
        })
        .catch((error) => {
          toastr.error("Амжилтгүй!", "Амжилтгүй");
        })
      setDeleteModal(false);
    }
  };
  const handleJobClicks = () => {
    setIsEdit(false);
    setPositionOne(null);
    toggle();
  };

  const columns = useMemo(
    () => [
      {
        header: '№',
        accessorKey: "position_id",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cellProps: any) => {
          return <Link to="#" className="text-body fw-bold">{cellProps.row.original.position_id}</Link>
        }
      },
      {
        header: "Албан тушаал",
        accessorKey: "position_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: "Албан тушаал 2",
        accessorKey: "position_display",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Харьяа байгууллага',
        accessorKey: "organization_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Хэлтэс',
        accessorKey: "department_name",
        enableColumnFilter: false,
        enableSorting: true,
      },
      {
        header: 'Үйлдэл',
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cellProps: any) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-info"
                  onClick={(event: any) => {
                    const positionData = cellProps.row.original;
                    event.preventDefault();
                    handleJobClick(positionData);
                  }}
                >
                  <i className="mdi mdi-pencil-outline" id="edittooltip" />
                  <UncontrolledTooltip placement="top" target="edittooltip">
                    Засах
                  </UncontrolledTooltip>
                </Link>
              </li>

              <li>
                <Link
                  to="#"
                  className="btn btn-sm btn-soft-danger"
                  onClick={(event: any) => {
                    const selectRowData = cellProps.row.original;
                    event.preventDefault();
                    onClickDelete(selectRowData);
                  }}
                >
                  <i className="mdi mdi-delete-outline" id="deletetooltip" />
                  <UncontrolledTooltip placement="top" target="deletetooltip">
                    Soft delete
                  </UncontrolledTooltip>
                </Link>
              </li>
            </ul>

          );
        }
      },
    ],
    [handleJobClick]
  );


  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      position_name: positionOne?.position_name,
      position_display: positionOne?.position_display,
      department_id: positionOne?.department_id,
      organization_id: positionOne?.organization_id,
    },
    validationSchema: Yup.object({
      position_name: Yup.string().required("Утга оруулна уу !"),
      position_display: Yup.string().required("Утга оруулна уу !"),
      department_id: Yup.string().required("Утга оруулна уу !"),
      organization_id: Yup.string().required("Утга оруулна уу !"),
    }),
    onSubmit: (values: any) => {
      if (isEdit) {
        const updatePositionList = {
          id: positionOne ? positionOne.position_id : 0,
          position_name: values.position_name,
          position_display: values.position_display,
          organization_id: values.organization_id,
          department_id: values.department_id,
        };
        positionUpdate(updatePositionList)
      } else {
        const newPositionList = {
          position_name: values["position_name"],
          position_display: values["position_display"],
          department_id: values["department_id"],
          organization_id: values["organization_id"],
        };
        positionCreate(newPositionList)
      }
      validation.resetForm();
      toggle();
    },
  });

  return (
    <React.Fragment>
      <DeleteModal
        deleteName={positionOne?.position_name}
        show={deleteModal}
        onDeleteClick={handleDeletejob}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody className="border-bottom">
              <div className="d-flex align-items-center">
                <img src={positionSvg} alt="" height="50" />
                <div className="flex-grow-1 ms-3">
                  <h5 className="fw-semibold">Мэдээлэл</h5>
                  <ul className="list-unstyled hstack gap-2 mb-0">
                    <li>
                      <i className="mdi mdi-table-row-height"></i> <span className="text-muted fw-semibold">Нийт: {numberWithCommas(positionCount)}</span>
                    </li>
                  </ul>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    handleJobClicks();
                  }}
                  className="btn btn-success  btn-label"
                >
                  <i className="mdi mdi-file-plus-outline label-icon"></i> Шинээр нэмэх
                </button>
              </div>
            </CardBody>
            <CardBody>
              {
                isLoading ? <Spinners setLoading={setLoading} />
                  :
                  <TableContainer
                    setCustomPageSize={setCustomPageSize}
                    setCustomPageLength={setCustomPageLength}
                    customPagination={customPagination}
                    columns={columns}
                    data={positionList || ""}
                    isCustomPageSize={true}
                    // isGlobalFilter={true}
                    isPagination={true}
                    colWidth={2}
                    SearchPlaceholder="Хэрэглэгч хайх . . ."
                    tableClass="align-middle dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                    pagination="pagination"
                    paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                  />
              }
            </CardBody>
          </Card>

        </Col>
      </Row>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle} tag="h4">
          {!!isEdit ? "Албан тушаал засах" : "Албан тушаал нэмэх"}
        </ModalHeader>
        <ModalBody>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <Row>
              <Col xs={12}>
                <div className="mb-3">
                  <Label>Албан тушаал </Label>
                  <Input
                    name="position_name"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.position_name || ""}
                    invalid={
                      validation.touched.position_name && validation.errors.position_name ? true : false
                    }
                  />
                  {validation.touched.position_name && validation.errors.position_name ? (
                    <FormFeedback type="invalid">{validation.errors.position_name}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Албан тушаал 2</Label>
                  <Input
                    name="position_display"
                    type="text"
                    validate={{
                      required: { value: true },
                    }}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.position_display || ""}
                    invalid={
                      validation.touched.position_display && validation.errors.position_display ? true : false
                    }
                  />
                  {validation.touched.position_display && validation.errors.position_display ? (
                    <FormFeedback type="invalid">{validation.errors.position_display}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Харьяа байгууллага</Label>
                  <Input
                    name="organization_id"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.organization_id || ""}
                    invalid={
                      validation.touched.organization_id && validation.errors.organization_id ? true : false
                    }
                  >
                    <option value="" disabled> Сонгох </option>
                    {orgList?.map((org) => (
                      <option key={org.organization_id} value={org.organization_id}>
                        {org.name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.organization_id && validation.errors.organization_id ? (
                    <FormFeedback type="invalid">{validation.errors.organization_id}</FormFeedback>
                  ) : null}
                </div>

                <div className="mb-3">
                  <Label>Харьяа хэлтэс</Label>
                  <Input
                    name="department_id"
                    type="select"
                    className="form-select"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.department_id || ""}
                    invalid={
                      validation.touched.department_id && validation.errors.department_id ? true : false
                    }
                  >
                    <option value="" disabled> Сонгох </option>
                    {departmentList?.map((depart) => (
                      <option key={depart.department_id} value={depart.department_id}>
                        {depart.department_name}
                      </option>
                    ))}
                  </Input>
                  {validation.touched.department_id && validation.errors.department_id ? (
                    <FormFeedback type="invalid">{validation.errors.department_id}</FormFeedback>
                  ) : null}
                </div>

              </Col>
            </Row>
            <Row>
              <Col>
                <div className="text-end">
                  <Button type="submit" color="success" className="save-user" > Save</Button>
                </div>
              </Col>
            </Row>
          </Form>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
}


export default Detail;